import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import DragScrollProvider from 'drag-scroll-provider';
import BasicCard from "./BasicCard";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import "./BasicCardCarousel.css";

class BasicCardCarousel extends Component {

    render() {
        return (
            <BasicCardCarouselComponent {...this.props} />
        );
    }
}

class BasicCardCarouselComponentBase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nbUser: 0,
            filterByRelevance: false,
            sortedCapsules: this.sortCapsulesByDate(this.props.data)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            sortedCapsules: this.sortCapsulesByDate(nextProps.data),
        })
    }

    onOpenCapsule = (capsule) => {
        this.props.history.push(`/capsule/${capsule}`);
    }

    changeCapsuleFilter = () => {
        const { filterByRelevance } = this.state
        if (filterByRelevance) {
            this.setState({ filterByRelevance: false, sortedCapsules: this.sortCapsulesByDate(this.props.data) })
        }
        else {
            this.setState({ filterByRelevance: true, sortedCapsules: this.sortCapsulesByRelevance(this.props.data) })
        }
    };

    sortCapsulesByRelevance = (capsules) => {

        capsules.forEach(capsule => {
            let sortingScore = 10 // starts at 10 but can go to 20
            let nbUsersCompany = localStorage.getItem("nbUsersCompany")
            sortingScore += capsule.nbLikes / (0.05 * nbUsersCompany) //adds a point every 5% of likes
            sortingScore += capsule.nbIdeas ? capsule.nbIdeas : 0 //adds a point for every idea
            sortingScore += capsule.nbLikeIdeas ? capsule.nbLikeIdeas / (0.02 * nbUsersCompany) : 0 //adds a point for every 2% of likes of ideas

            let finalScore = sortingScore > 20 ? 20 : sortingScore < 0 ? 0 : sortingScore

            if (!capsule.sortingScore || capsule.sortingScore !== finalScore) {
                this.props.firebase.db.collection('capsules').doc(capsule.id).update({ sortingScore: finalScore })
            }

            capsule.sortingScore = sortingScore > 20 ? 20 : sortingScore < 0 ? 0 : sortingScore


        })
        capsules.sort((capsuleA, capsuleB) => capsuleB.sortingScore - capsuleA.sortingScore)
        return capsules
    }

    sortCapsulesByDate = (capsules) => {
        let sortedCapsulesByDate = JSON.parse(JSON.stringify(capsules))
        sortedCapsulesByDate.sort((capsuleA, capsuleB) => capsuleB.creationDate - capsuleA.creationDate)
        return sortedCapsulesByDate
    }

    render() {
        const { data, ...other } = this.props;
        const { sortedCapsules } = this.state
        return (

            <div className="basic-card-carousel-container">
                <DragScrollProvider>
                    {({ onMouseDown, ref }) => (
                        <div className="basic-card-scrolling-wrapper"
                            ref={ref}
                            onMouseDown={onMouseDown}>

                            {data.length === 0 ?
                                <div className="basic-card-carousel-empty">
                                    <div className="basic-card-carousel-empty-text">Aucune capsule pour l'instant...</div>
                                </div> :
                                sortedCapsules.map((value, index) => {
                                    return (
                                        <div className="basic-card-container" key={value.id}>
                                            <BasicCard
                                                cardIndex={index + 1}
                                                capsule={value}
                                                onOpenCapsule={this.onOpenCapsule}
                                                {...other}
                                            />
                                        </div>
                                    )
                                })}

                        </div>
                    )}
                </DragScrollProvider>
                <div className="d-flex justify-content-center">
                    <MuiThemeProvider theme={theme}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.filterByRelevance}
                                    onChange={() => this.changeCapsuleFilter()}
                                    value="filterChecked"
                                    color="primary"
                                />
                            }
                            label="Tri par pertinence"
                        />
                    </MuiThemeProvider>
                </div>
            </div>
        );
    }
}

const theme = createMuiTheme({
    palette: {
        primary: { main: '#0070A2' },
    },
    typography: { useNextVariants: true },
});

const BasicCardCarouselComponent = withRouter(withFirebase(BasicCardCarouselComponentBase));


export default BasicCardCarousel;
export { BasicCardCarouselComponent };